import React, { memo, useCallback, useEffect, useRef } from 'react';
import NavigationCloseButton from 'design-system/NavigationCloseButton';
const EmmaProModalCloseButton = ({ onClose, showTrial, onPressIn, onPressOut, }) => {
    const closing = useRef(false);
    const timeoutRef = useRef(undefined);
    const onPress = useCallback(() => {
        if (closing.current)
            return;
        closing.current = true;
        onClose?.();
        timeoutRef.current = setTimeout(() => {
            closing.current = false;
        }, 500);
    }, [onClose]);
    useEffect(() => () => {
        clearTimeout(timeoutRef.current);
    }, []);
    return (<NavigationCloseButton onPress={onPress} onPressIn={onPressIn} onPressOut={onPressOut} colorKey={showTrial ? 'secondaryTransparent' : 'primary'}/>);
};
export default memo(EmmaProModalCloseButton);
